import React from 'react';
import {TouchableOpacity, View} from 'react-native';
import {IStateProps} from './model';
import {StyleHelper, useStyles} from '../../hooks/styles';
import {images} from '../../../assets/icons';
import {stylePatterns} from '../../theme/patterns';
import {DeviceSize} from '../../theme/helpers';
import {Text} from '../text';

export default ({onPress, disabled}: IStateProps) => {
  const {Clip} = images;
  const styles = useStyles((helper) => createStyle(helper));

  return (
    <TouchableOpacity testID='file-picker-id' disabled={disabled} onPress={onPress} style={styles.wrap}>
      <Text style={styles.text}>Приложить файл</Text>
      <View style={styles.clip}>
        <Clip width={20} height={20} color={styles.clip.color} />
      </View>
    </TouchableOpacity>
  );
};

const createStyle = ({theme, mediaOnly}: StyleHelper) => ({
  wrap: {
    ...stylePatterns.flexCenterVertical,
    minHeight: 20,
  },
  clip: {
    width: 20,
    height: 20,
    color: theme.filePicker.clipColor,
  },
  text: {
    paddingRight: 12,
    color: theme.filePicker.clipColor,
    ...mediaOnly(DeviceSize.desktop, theme.fonts.h5Light, theme.fonts.bodySmallLight),
  },
});
